import { SamProcessor } from "../sam/processing_sam.js";

export class Sam2Processor extends SamProcessor { }
export class Sam2VideoProcessor extends Sam2Processor { }
